import RequestResetPassword from './RequestResetPassword'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import { clear, requestPasswordReset } from '../../../store/modules/session'
import { componentWillUnmount } from '../../../components/Lifecycles'

const mapStateToProps = state => ({
  locale: state.router.locale,
  email: state.profile.user.email,
  error: state.session.error,
  success: state.session.isSuccessfullySubmitted,
  isRequesting: state.session.isSubmitting,
})

const mapDispatchToProps = dispatch => ({
  requestResetPassword: compose(dispatch, requestPasswordReset),
  clear: compose(dispatch, clear),
})

// willUnmount :: Props -> Action CLEAR
const willUnmount = ({ clear }) => clear()

// lifecycles :: React.Component -> React.Component
const lifecycles = componentWillUnmount(willUnmount)(RequestResetPassword)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)
